"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHeader = void 0;
var HttpHeader;
(function (HttpHeader) {
    HttpHeader["Authorization"] = "Authorization";
    HttpHeader["ContentType"] = "Content-Type";
    HttpHeader["ContentDisposition"] = "Content-Disposition";
    HttpHeader["ContentLength"] = "Content-Length";
})(HttpHeader = exports.HttpHeader || (exports.HttpHeader = {}));
